import { defineAction } from '~/prix'
import citizenDeleteAction from './citizenDelete.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const citizenDeleteDefinition = defineAction({
  ...citizenDeleteAction,

  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default citizenDeleteDefinition
